const SW_TYPE_HANDLERS = {};

navigator.serviceWorker?.ready?.then(() => {
  navigator.serviceWorker?.addEventListener("message", swMessageCallback);
});

export const postMessageToServiceWorker = (data) => {
  navigator.serviceWorker?.controller?.postMessage(data);
};

function swMessageCallback(event) {
  const { data = {} } = event;
  const { type } = data;
  SW_TYPE_HANDLERS[type] && SW_TYPE_HANDLERS[type](data);
}

export function registerServiceWorkerListenerTypes(type, callback) {
  if (type && callback) {
    SW_TYPE_HANDLERS[type] = callback;
  }
}
